import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  leaveTypes: [],
  leaveTypesLoading: false,
  leaveTypesError: null,

  leaveSummary: null,
  leaveSummaryLoading: false,
  leaveSummaryError: null,

  myLeaves: [],
  myLeavesLoading: false,
  myLeavesError: null,

  applyLoading: false,
  applyError: null,

  cancelLoading: false,
  cancelError: null,

  selectedLeave: null,
};

const leaveSlice = createSlice({
  name: "applyLeave",
  initialState,
  reducers: {
    // Get Leave Types
    getLeaveTypesStart: (state) => {
      state.leaveTypesLoading = true;
      state.leaveTypesError = null;
    },
    getLeaveTypesSuccess: (state, action) => {
      state.leaveTypesLoading = false;
      state.leaveTypes = action.payload;
      state.leaveTypesError = null;
    },
    getLeaveTypesFailure: (state, action) => {
      state.leaveTypesLoading = false;
      state.leaveTypesError = action.payload;
    },

    // Get Leave Summary
    getLeaveSummaryStart: (state) => {
      state.leaveSummaryLoading = true;
      state.leaveSummaryError = null;
    },
    getLeaveSummarySuccess: (state, action) => {
      state.leaveSummaryLoading = false;
      state.leaveSummary = action.payload;
      state.leaveSummaryError = null;
    },
    getLeaveSummaryFailure: (state, action) => {
      state.leaveSummaryLoading = false;
      state.leaveSummaryError = action.payload;
    },

    // Get My Leaves
    getMyLeavesStart: (state) => {
      state.myLeavesLoading = true;
      state.myLeavesError = null;
    },
    getMyLeavesSuccess: (state, action) => {
      state.myLeavesLoading = false;
      state.myLeaves = action.payload;
      state.myLeavesError = null;
    },
    getMyLeavesFailure: (state, action) => {
      state.myLeavesLoading = false;
      state.myLeavesError = action.payload;
    },

    // Apply Leave
    applyLeaveStart: (state) => {
      state.applyLoading = true;
      state.applyError = null;
    },
    applyLeaveSuccess: (state, action) => {
      state.applyLoading = false;
      state.applyError = null;
      state.selectedLeave = action.payload; 
    },
    applyLeaveFailure: (state, action) => {
      state.applyLoading = false;
      state.applyError = action.payload;
    },

    // Cancel Leave
    cancelLeaveStart: (state) => {
      state.cancelLoading = true;
      state.cancelError = null;
    },
    cancelLeaveSuccess: (state, action) => {
      state.cancelLoading = false;
      state.cancelError = null;
      if (state.selectedLeave && state.selectedLeave.id === action.payload.id) {
        state.selectedLeave = null;
      }
    },
    cancelLeaveFailure: (state, action) => {
      state.cancelLoading = false;
      state.cancelError = action.payload;
    },

    // Set Selected Leave
    setSelectedLeave: (state, action) => {
      state.selectedLeave = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.leaveTypesError = null;
      state.leaveSummaryError = null;
      state.myLeavesError = null;
      state.applyError = null;
      state.cancelError = null;
    },
  },
});

export const {
  getLeaveTypesStart,
  getLeaveTypesSuccess,
  getLeaveTypesFailure,
  getLeaveSummaryStart,
  getLeaveSummarySuccess,
  getLeaveSummaryFailure,
  getMyLeavesStart,
  getMyLeavesSuccess,
  getMyLeavesFailure,
  applyLeaveStart,
  applyLeaveSuccess,
  applyLeaveFailure,
  cancelLeaveStart,
  cancelLeaveSuccess,
  cancelLeaveFailure,
  setSelectedLeave,
  clearError,
} = leaveSlice.actions;

export default leaveSlice.reducer;